// libs
import { connect } from "react-redux";

// redux
import {
    allowXHRRequests,
    openCountryCurrencySettings,
} from "shared/store/internationalization/actions";
import { getXHRStatus, onGDPRNetwork } from "shared/store/internationalization/selectors";

// components
import CookiesConsent from "./CookiesConsent";

const mapStateToProps = (state: any) => {
    return {
        onGDPRNetwork: onGDPRNetwork(state),
        isXHRAllowed: getXHRStatus(state),
    };
};

const mapDispatchToProps = { openCountryCurrencySettings, allowXHRRequests };

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CookiesConsent);
